export default __webpack_public_path__ + "71917fffb4d4496484b4500a71cc2d9c.png";